/**
 * DetailBackgroundContainer component.
 */
import styled from 'styled-components';

/**
 * Styled detail background container.
 */
const DetailBackgroundContainer = styled.div`
  background: #1f1f1f;
  position: absolute;
  height: 100vh;
  width: 100vw;
`;

export default DetailBackgroundContainer;
